<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="refundSchedule">
            <van-nav-bar
                title="回款进度"
                left-text="合同列表"
                left-arrow
                @click-left="onClickLeft"
            >
            </van-nav-bar>
            <section>
                <header>
                    <div class="headerContent">
                        <div class="head">
                            <h3>{{ detail.client_name }}</h3>
                            <p>{{ detail.engineering_name }}</p>
                        </div>
                        <van-divider></van-divider>
                        <div class="progress-wrapper">
                            <div class="progress-content">
                                <template v-if="progressWidth<=100">
                                    <p :style="{width: `${progressWidth}%`}"></p>
                                    <span :style="{left: `calc(${progressWidth}% - 17px)`}">{{ progressWidth }}%</span>
                                </template>
                                <template v-else>
                                    <p :style="{width: `${100}%`}"></p>
                                    <span :style="{left: `calc(${100}% - 37px)`}">{{ progressWidth }}%</span>
                                </template>
                            </div>
                        </div>
                        <div class="sort">
                            <!-- <div class="Paid">
                                <h5 class="iconfont iconjine">
                                    应收总额
                                </h5>
                                <p>{{ detail.sales_amount }}万</p>
                            </div>
                            <div class="Arrears">
                                <h5 class="iconfont iconjine">
                                    实收总额
                                </h5>
                                <p>{{ detail.cashed_amount }}万</p>
                            </div> -->
                            <div class="row">
                                <div class="item itemGreen">
                                    <p class="text">
                                        销售金额
                                    </p>
                                    <div class="money" :title="detail.sales_amount">
                                        {{ detail.sales_amount }}万
                                    </div>
                                </div>
                                <div class="item itemOrange">
                                    <p class="text">
                                        按节点应收
                                    </p>
                                    <div class="money" :title="detail.aggregate_receivables">
                                        {{ detail.aggregate_receivables }}万
                                    </div>
                                </div>
                                <div class="item itemBlue">
                                    <p class="text">
                                        累计收款
                                    </p>
                                    <div class="money" :title="detail.aggregate_official_receipt">
                                        {{ detail.aggregate_official_receipt }}万
                                    </div>
                                </div>
                                <div class="item itemYellow">
                                    <p class="text">
                                        累计尾款
                                    </p>
                                    <div class="money" :title="detail.balance_payment_amount">
                                        {{ detail.balance_payment_amount }}万
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="item itemPurple">
                                    <p class="text">
                                        实时余款
                                    </p>
                                    <div class="money" :title="detail.realTimeBalance">
                                        {{ detail.realTimeBalance }}万
                                    </div>
                                </div>
                                <div class="item itemRed">
                                    <p class="text">
                                        累计欠款
                                    </p>
                                    <div class="money" :title="detail.overdue_arrears">
                                        {{ detail.overdue_arrears }}万
                                    </div>
                                </div>
                                <div class="item itemBlue">
                                    <p class="text">
                                        累计回款率
                                    </p>
                                    <div class="money" :title="detail.cumulative_return_rate">
                                        {{ detail.cumulative_return_rate }}%
                                    </div>
                                </div>
                                <div class="item itemRed">
                                    <p class="text">
                                        合同总欠款
                                    </p>
                                    <div class="money" :title="detail.cumulative_balance">
                                        {{ detail.cumulative_balance }}万
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
                <div class="list-wrapper">
                    <ul v-if="listData.length > 0">
                        <li v-for="(item,index) in listData" :key="index" class="item">
                            <h4>
                                <p class="van_left">
                                    回款日期：{{ item.settlement_time }}
                                </p>
                            </h4>
                            <div class="engineeringInfo">
                                <h4>
                                    <span class="iconfont iconhetong">合同编号：{{ detail.contract_number }}</span>
                                </h4>
                                <div class="chart">
                                    <van-circle
                                        v-model="item.currentRate"
                                        :rate="getRate(item)"
                                        :size="50"
                                        :speed="100"
                                        :text="getRate(item)+'%'"
                                        color="#3495FB"
                                        layer-color="#d5e9fe"
                                        :stroke-width="100"
                                    ></van-circle>
                                    <p>回款率</p>
                                </div>
                                <p>
                                    <img src="@/assets/images/icons/icon_30.png" alt="">
                                    <span>结算方量：{{ item.volumes }}m³</span>
                                </p>
                                <p>
                                    <img src="@/assets/images/icons/icon_26.png" alt="">
                                    <span>欠款金额：¥{{ item.ending_balance_receivable }}元</span>
                                </p>
                                <p>
                                    <img src="@/assets/images/icons/icon_26.png" alt="">
                                    <span>尾款金额：¥{{ item.loans_receivable }}元</span>
                                </p>
                            </div>
                        </li>
                    </ul>
                    <div v-else class="no_data"></div>
                </div>
            </section>
        </div>
    </v-touch>
</template>
<script>
export default {
    // 回款进度
    name: 'refund-schedule',
    components: {},
    props: {},
    data() {
        return {
            listData: [], // 回款进度列表
            detail: this.$route.params.obj, // 上一个带过来的工程基本信息
        };
    },
    computed: {
        // 根据回款额算出比例
        // progressWidth() {
        //     if (this.detail.cashed_amount === 0 && this.detail.sales_amount === 0) {
        //         return 0;
        //     }
        //     return Math.floor(this.detail.cashed_amount / this.detail.sales_amount * 100);
        // },
    },
    watch: {},
    created() {
        // 获取回款进度列表
        this.getContractProgressList();
        const detail = JSON.parse(JSON.stringify(this.$route.params.obj));
        if (detail) {
            detail.sales_amount = (Number(detail.sales_amount) / 10000).toFixed(2);
            detail.aggregate_receivables = (Number(detail.aggregate_receivables) / 10000).toFixed(2);
            detail.aggregate_official_receipt = (Number(detail.aggregate_official_receipt) / 10000).toFixed(2);
            detail.balance_payment_amount = (Number(detail.balance_payment_amount) / 10000).toFixed(2);
            detail.realTimeBalance = (Number(detail.sales_amount) - Number(detail.aggregate_official_receipt)).toFixed(2);
            detail.overdue_arrears = (Number(detail.overdue_arrears) / 10000).toFixed(2);
            // detail.cumulative_return_rate = detail.cumulative_return_rate;
            detail.cumulative_balance = (Number(detail.cumulative_balance) / 10000).toFixed(2);
            this.progressWidth = detail.cumulative_return_rate;
            // if (this.progressWidth > 100) {
            //     this.progressWidth = 100;
            // }
        }
        this.detail = detail;
    },
    mounted() {},
    destroyed() {},
    methods: {
        getContractProgressList() {
            this.$axios
                // .get('/interfaceApi/sale/accounts/get_contract_progress/123456')
                .get('/interfaceApi/sale/accounts/get_contract_progress/' + this.detail.contract_number)
                .then(res => {
                    this.listData = res;
                })
                .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        getRate(item) {
            let rate = 0;
            if (!item.official_receipt) {
                item.official_receipt = 0;
            }
            if (!item.loans_receivable) {
                item.loans_receivable = 0;
            }
            if (item.loans_receivable !== 0) {
                rate = Math.floor(item.official_receipt / item.loans_receivable * 100);
            }
            return rate;
        },
    },
};
</script>
<style lang="stylus" scoped>
@import '~@/assets/styles/mixins.styl';
.refundSchedule
    height 100%
    section
        height calc(100% - 45rpx)
        overflow: scroll;
        -webkit-overflow-scrolling: touch;
        background #F0F0F0
        display flex
        flex-direction column
        header
            // height 150rpx
            background #2b5dab
            padding 15rpx
            .headerContent
                height 100%
                background 100%
                background #fff
                border-radius 4rpx
                .head
                    padding 14rpx
                    h3
                        font-size 16rpx
                        color #333333
                        margin-bottom 10rpx
                    p
                        font-size 14rpx
                        color #979EA7
                .van-divider
                    margin 0
                .progress-wrapper
                    padding 25rpx 15rpx 10rpx 15rpx
                    .progress-content
                        height 18rpx
                        background rgba(254,247,235,1)
                        border 2px solid rgba(250,132,54,1)
                        border-radius 10px
                        // overflow hidden
                        position relative
                        p
                            height 10rpx
                            background #3495FB
                            border-radius 10rpx
                            margin-top 2rpx
                            margin-left 2rpx
                            transition all 2s
                        span
                            background #3495FB
                            padding 0 2rpx
                            height 20rpx
                            color #ffffff
                            position absolute
                            top -22rpx
                            // left calc(58% - 15rpx)
                            font-size 12rpx
                            border-radius 4rpx
                            text-align center
                            line-height 20rpx
                            &::after
                                content ""
                                width 0
                                height 0
                                border 4rpx solid
                                border-color #3495FB transparent  transparent  transparent
                                position absolute
                                left 50%
                                margin-left -3rpx
                                bottom -8rpx
                .sort
                    overflow hidden
                    position relative
                    .row
                        display flex
                        justify-content space-around
                        .item
                            flex 1
                            margin 5rpx
                            .text
                                font-size 12rpx
                                color #979EA7
                                text-align center
                            .money
                                width 80rpx
                                text-ellipsis()
                                height 20rpx
                                text-align center
                                line-height 20rpx
                                margin-top 3rpx
                                border-radius 4rpx
                                font-size 14rpx
                        .itemGreen
                            .money
                                background rgba(33, 189, 204, 0.06)
                                color #21BDCC
                        .itemOrange
                            .money
                                background rgba(250, 132, 54, 0.06)
                                color #FA8436
                        .itemBlue
                            .money
                                background rgba(85, 136, 241, 0.06)
                                color #5588F1
                        .itemYellow
                            .money
                                background rgba(248, 165, 1, 0.06)
                                color #F8A501
                        .itemPurple
                            .money
                                background rgba(134, 107, 238, 0.06)
                                color #866BEE
                        .itemRed
                            .money
                                background rgba(253, 111, 100, 0.06)
                                color #FD6F64
        .list-wrapper
            position: relative
            flex 1
            .no_data
                padding-top 10rpx
                text-align center
            ul
                padding 15rpx
                li
                    margin-bottom 10rpx
                    h4
                        overflow hidden
                        margin-bottom 10rpx
                        font-size 12rpx
                        p
                            color #979EA7
                        span
                            color #E60000
                    .van_left
                        font-size 12rpx
                        color #979EA7
                        // margin-bottom 10rpx
                        position relative
                        height 20rpx
                        line-height 20rpx
                        padding-left 20rpx
                        &::after
                            content ""
                            width 10rpx
                            height 10rpx
                            border-radius 50%
                            background rgba(230,0,0,1);
                            opacity 0.2;
                            position absolute
                            top 5rpx
                            left 0
                        &::before
                            content ""
                            width 5rpx
                            height 5rpx
                            border-radius 50%
                            background rgba(230,0,0,1);
                            position absolute
                            top 7.5rpx
                            left 2.5rpx
                    .engineeringInfo
                        position relative
                        padding 15rpx
                        background #fff
                        border-radius 4rpx
                        img,span
                            float left
                            height 16rpx
                            line-height 16rpx
                        img
                            width 16rpx
                            margin-right 12rpx
                        h4,p
                            overflow hidden
                        h4
                            margin-bottom 14rpx
                            span
                                font-size 18rpx
                                height 20rpx
                                line-height 20rpx
                                color #061F3E
                                &:before
                                    font-size 20rpx
                                    margin-right 10rpx
                                    color #3495FB

                        .chart
                            position absolute
                            right 20rpx
                            top 60%
                            transform translateY(-50%)
                            p
                                font-size 14rpx
                                text-align center
                                color #3495FB
                        p
                            margin-bottom 14rpx
                            &:last-child
                                margin-bottom 0
                            span
                                display inline-block
                                width calc(100% - 40rpx)
                                overflow hidden
                                text-overflow ellipsis
                                white-space nowrap
                                font-size 14rpx
                                color #666666
                        .state
                            position absolute
                            top 0
                            right 0
                            font-weight 400
                            width 40rpx
                            height 40rpx
                            &:before
                                font-size 40rpx
                                line-height 40rpx
                                color #FF6600
                                position absolute
                                top 0px
                                right 0
                            i
                                position absolute
                                width 40rpx
                                text-align center
                                font-size 12rpx
                                color #FFFFFF
                                transform rotate(45deg)
                                top 7rpx
                                left 7rpx
                        .van-divider
                            margin 0
</style>